import { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';

interface StartViewProps {
  onStart: () => void;
}

export function StartView({ onStart }: StartViewProps) {
  const rootRef = useRef<HTMLElement>(null);

  useGSAP(
    () => {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) {
        gsap.from(rootRef.current, { opacity: 0, duration: 0.2 });
        return;
      }

      const timeline = gsap.timeline({ defaults: { ease: 'power3.out' } });
      timeline
        .from('.start-copy > *', {
          opacity: 0,
          y: 28,
          duration: 0.62,
          stagger: 0.08,
        })
        .from('.start-visual__blob', {
          opacity: 0,
          scale: 0.88,
          rotation: -5,
          duration: 0.72,
        }, 0.08)
        .from('.start-visual__photo', {
          opacity: 0,
          scale: 0.9,
          y: 22,
          duration: 0.72,
        }, 0.18)
        .from('.start-visual__badge', {
          opacity: 0,
          scale: 0.4,
          rotation: -22,
          duration: 0.55,
          ease: 'back.out(1.8)',
        }, 0.55);

      gsap.to('.start-visual__blob', {
        borderRadius: '48% 52% 58% 42% / 54% 45% 55% 46%',
        rotation: -1,
        duration: 6,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
      });
      gsap.to('.start-visual__badge', {
        y: -10,
        rotation: 10,
        duration: 2.8,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
      });
    },
    { scope: rootRef },
  );

  return (
    <section ref={rootRef} className="view start-view">
      <div className="start-copy">
        <span className="eyebrow">QUIZ INTERACTIF · SENSIBILISATION</span>
        <h1 className="display-title">
          <span>LES BONS</span>
          <span className="outline">RÉFLEXES</span>
        </h1>
        <p className="start-subtitle">
          Testez vos connaissances et découvrez les bons gestes pour un nettoyage
          plus sûr et plus efficace.
        </p>
        <p className="start-arabic" dir="rtl">
          اختبر معلوماتك وتعرّف على الممارسات الصحيحة لتنظيف أكثر أماناً وفعالية.
        </p>
        <button type="button" className="start-cta" onClick={onStart}>
          <span className="start-cta__keys"><span className="keycap">1</span></span>
          <span>Appuyez pour commencer</span>
        </button>
      </div>

      <div className="start-visual" aria-hidden="true">
        <div className="start-visual__blob" />
        <img className="start-visual__photo" src="assets/bg3.png" alt="" />
        <img className="start-visual__badge" src="assets/vitamine.png" alt="" />
      </div>
    </section>
  );
}
